import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer  } from '@angular/platform-browser';

/**
 * DomseguroPipe
 * 
 * @author Fran Aragon
 *
 * Pipe used to Sanitize Url string for security
 */
@Pipe({
    name: 'domseguro'
})
export class DomseguroPipe implements PipeTransform {

    /**
     * @ignore
     */
    constructor( private domSanitizer:DomSanitizer ){ }

    /**
     * Pipe used to Sanitize Url string for security
     *
     * @param {string} url
     */
    transform( url: string): any {
        return this.domSanitizer.bypassSecurityTrustResourceUrl( url );
    }

}